import { Appointment } from "./appointment";

/**
 * DxScheduler event for clicking on empty cell
 */
export class CellClickEvent {
    // used to cancel the event
    cancel?: boolean;

    cellData: CellData;
    cellElement: HTMLElement;
    component: any;
    event: Event;
}

export class CellUpdateEvent {
    cancel?: boolean;
    newData: Appointment;
    oldData: Appointment;
}


export class CellData {
    allDay: boolean;
    startDate: Date;
    endDate: Date;
}
